import { jsx } from "react/jsx-runtime";
import DealerInfoButtons from "./DealerInfoButtons.js";
import DealerInfoButtonsSkeleton from "./DealerInfoButtonsSkeleton.js";
import DealerInfoExtra from "./DealerInfoExtra.js";
import DealerInfoExtraSkeleton from "./DealerInfoExtraSkeleton.js";
import { DealerInfoHeader } from "./DealerInfoHeader.js";
import DealerInfoHeaderSkeleton from "./DealerInfoHeaderSkeleton.js";
import DealerInfoPhones from "./DealerInfoPhones.js";
import DealerInfoPhonesSkeleton from "./DealerInfoPhonesSkeleton.js";
import DealerInfoRating from "./DealerInfoRating.js";
import DealerInfoRatingSkeleton from "./DealerInfoRatingSkeleton.js";
import DealerInfoSchedule from "./DealerInfoSchedule.js";
import DealerInfoScheduleSkeleton from "./DealerInfoScheduleSkeleton.js";
import DealerInfoServices from "./DealerInfoServices.js";
import DealerInfoServicesSkeleton from "./DealerInfoServicesSkeleton.js";
import DealerInfoSite from "./DealerInfoSite.js";
import DealerInfoSiteSkeleton from "./DealerInfoSiteSkeleton.js";
import DealerInfoTitle from "./DealerInfoTitle.js";
import DealerInfoTitleSkeleton from "./DealerInfoTitleSkeleton.js";
import classnames from "../../utils/classnames.js";
import './DealerInfo.css';/* empty css                */
const DealerInfo = ({ className, children }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info", className), children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info__body"), children }) });
};
DealerInfo.Header = DealerInfoHeader;
DealerInfo.HeaderSkeleton = DealerInfoHeaderSkeleton;
DealerInfo.Title = DealerInfoTitle;
DealerInfo.TitleSkeleton = DealerInfoTitleSkeleton;
DealerInfo.Phones = DealerInfoPhones;
DealerInfo.PhonesSkeleton = DealerInfoPhonesSkeleton;
DealerInfo.Schedule = DealerInfoSchedule;
DealerInfo.ScheduleSkeleton = DealerInfoScheduleSkeleton;
DealerInfo.Site = DealerInfoSite;
DealerInfo.SiteSkeleton = DealerInfoSiteSkeleton;
DealerInfo.Services = DealerInfoServices;
DealerInfo.ServicesSkeleton = DealerInfoServicesSkeleton;
DealerInfo.Rating = DealerInfoRating;
DealerInfo.RatingSkeleton = DealerInfoRatingSkeleton;
DealerInfo.Extra = DealerInfoExtra;
DealerInfo.ExtraSkeleton = DealerInfoExtraSkeleton;
DealerInfo.Buttons = DealerInfoButtons;
DealerInfo.ButtonsSkeleton = DealerInfoButtonsSkeleton;
export {
  DealerInfo as default
};
//# sourceMappingURL=DealerInfo.js.map
